import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DotCMSPageAssetContainer } from 'dotcms/src/lib/models';
import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { Observable } from 'rxjs';
import { CustomDotCmsLayoutContainer } from '../../../models/page/custom-dot-cms-page.model';
import { isInsideEditor } from '@dotcms/client';

@Component({
  selector: 'custom-dot-cms-container',
  templateUrl: './dot-cms-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsContainerComponent implements OnInit {
  @Input() layoutContainers: CustomDotCmsLayoutContainer[];
  deviceType$: Observable<DeviceType>;
  @Input() columnWidth: number;
  isEditMode = isInsideEditor();

  pageAssetContainers$: Observable<DotCMSPageAssetContainer>;

  constructor(private appFacade: AppFacade) {}
  ngOnInit(): void {
    this.deviceType$ = this.appFacade.deviceType$;
  }
}
